import RouteStore from '../../stores/RouteStore';
import { useFluxible } from './useFluxible';
export var useCurrentRoute = function () {
    var context = useFluxible();
    var currentRoute = context.getStore(RouteStore).getCurrentRoute();
    return currentRoute;
};
